export const blockIconsMapsHomeRepairServiceNew = (
	<span className='material-symbols-outlined'>home_repair_service</span>
);
